export default __webpack_public_path__ + "static/media/voxoconnect.b1aa90b3.png";